export const TIERS = {
  member: { label: "Member", level: 1, color: "text-zinc-300", chip: "bg-zinc-800 text-zinc-300" },
  elite_cultist: { label: "Elite Cultist", level: 2, color: "text-violet-400", chip: "bg-violet-900/40 text-violet-200 border border-violet-500/40" },
  hardcore_cultist: { label: "Hardcore Cultist", level: 3, color: "text-rose-400", chip: "bg-rose-900/40 text-rose-200 border border-rose-500/40" },
  god_tier_supporter: { label: "God Tier Supporter", level: 4, color: "text-amber-300", chip: "bg-gradient-to-r from-amber-500/30 via-yellow-500/30 to-amber-500/30 text-amber-100 border border-amber-400/60" },
  admin: { label: "Founder", level: 99, color: "username-founder", chip: "badge-founder" },
  public: { label: "Public", level: 0, color: "text-zinc-400", chip: "bg-zinc-900 text-zinc-400" },
};

// Top supporter badges (separate from primary role)
export const BADGES = {
  cult_master: {
    label: "Cult Master",
    short: "CULT MASTER",
    color: "text-rose-100",
    // Red → Black → Red animated gradient + red glow
    className: "badge-cult-master inline-flex items-center gap-1 px-2 py-0.5 rounded text-[10px] font-bold uppercase tracking-wider",
  },
  top_1_supporter: {
    label: "Top 1 Supporter All Time",
    short: "TOP 1",
    color: "text-amber-200",
    // Gold + Crimson glow, animated
    className: "badge-top1 inline-flex items-center gap-1 px-2 py-0.5 rounded text-[10px] font-bold uppercase tracking-wider",
  },
  top_2_supporter: {
    label: "Top 2 Supporter All Time",
    short: "TOP 2",
    color: "text-zinc-100",
    // Silver glow, animated
    className: "badge-top2 inline-flex items-center gap-1 px-2 py-0.5 rounded text-[10px] font-bold uppercase tracking-wider",
  },
  top_3_supporter: {
    label: "Top 3 Supporter All Time",
    short: "TOP 3",
    color: "text-orange-200",
    // Bronze glow, animated
    className: "badge-top3 inline-flex items-center gap-1 px-2 py-0.5 rounded text-[10px] font-bold uppercase tracking-wider",
  },
};

export const ACCESS_OPTIONS = [
  { value: "public", label: "Public — Everyone" },
  { value: "member", label: "Member — Registered users" },
  { value: "elite_cultist", label: "Elite Cultist" },
  { value: "hardcore_cultist", label: "Hardcore Cultist" },
  { value: "god_tier_supporter", label: "God Tier Supporter" },
];

export function canAccess(userRole, required) {
  if (userRole === "admin") return true;
  return (TIERS[userRole]?.level ?? 0) >= (TIERS[required]?.level ?? 0);
}

export function formatRp(n) {
  if (n == null) return "Rp 0";
  return "Rp " + Number(n).toLocaleString("id-ID");
}

export function daysLeft(endIso) {
  if (!endIso) return 0;
  const end = new Date(endIso).getTime();
  const now = Date.now();
  return Math.max(0, Math.ceil((end - now) / 86400000));
}
